import React, { Component } from 'react'
import { Mobile, Desktop } from '../../../media'
import styled from "styled-components";

const Header = styled.h2`
    cursor: pointer;
    width: 930px;
    margin: 0 auto;
    padding-left: 15px;
    padding-right: 15px;

    font-family: Lato-Light;
    font-size: 24px;
    font-weight: normal;
    
    color: #2b2b2b;
    text-align: left;
    line-height: 28px;
    border-bottom: 1px solid #CCCCCC;

    // Mobile version.
    @media (max-width: 768px) {
      width: auto;
      padding-left: 15px;
      margin: 0;
    }

    > span {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #1d71bb;
      text-align: right;
      line-height: 28px;
      text-decoration: none;
      float: right;
      vertical-align: middle;

      // Mobile version.
      @media (max-width: 768px) {
        margin-right: 0;
      }
    }

    > span:before {
        content: "${props => props.showSectionLink != null ? props.showSectionLink : ''}";

        // Mobile version.
        @media (max-width: 768px) {
            content: "${props => props.showSectionLinkForMobile != null ? props.showSectionLinkForMobile : ''}";
        }
    }

    &[aria-expanded=true] {
        > span:before {
            content: "${props => props.hideSectionLink != null ? props.hideSectionLink : ''}";

            // Mobile version.
            @media (max-width: 768px) {
                content: "${props => props.hideSectionLinkForMobile != null ? props.hideSectionLinkForMobile : ''}";
            }
        }
    }
`

class SectionTitle extends Component {

    render() {
        return (
            <Header showSectionLink={this.props.showSectionLink} 
                hideSectionLink={this.props.hideSectionLink}
                showSectionLinkForMobile={this.props.showSectionLinkForMobile}
                hideSectionLinkForMobile={this.props.hideSectionLinkForMobile}
                role="button" tabIndex={0} aria-expanded={this.props.expanded} aria-controls={this.props.sectionId}>
                {this.props.title}{" "}
                {this.props.showLink &&
                    <Desktop>
                        <span></span>
                    </Desktop>
                }
                {this.props.showLink &&
                    <Mobile>
                        <span></span>
                    </Mobile>
                }
            </Header>
        )
    }
}

export default SectionTitle;
